// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap___4Ed5","actionsCol":"EnrolledClinics_actionsCol__myrBN"};